module.exports = __webpack_public_path__ + "img/brand-cases4.f07a5d18.png";